export default theme => ({
  root: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    backgroundColor: theme.palette.grey[100]
  }
})
